import { Main } from "./main/Main";

window.addEventListener('DOMContentLoaded', () => {
    
    //abc
    const main = new Main();
    main.init();

});